// extracted by mini-css-extract-plugin
export default {"minHeight":"MandatoryQuestion_minHeight__afO-g","text":"MandatoryQuestion_text__qAj6Y","icon":"MandatoryQuestion_icon__NtMPs"};